import styled, { css } from 'styled-components'
import { layoutMaxSize, ZIndex } from 'src/styles/mixin'
import { Link } from 'react-router-dom'
import useScrollYPosition from 'src/hooks/useScrollYPosition.hook'
import { ReactNode } from 'react'
import { CustomSwiper } from 'src/components/common/CustomSwiper'
import { Container } from 'src/components/common/Container'
import usePageNav from 'src/hooks/usePageNav.hook'
import { CategoryListSpace } from 'src/types/api'
import { categoryListQueryOption, useCustomQuery } from 'src/hooks/react-query/useCustomQuery.hook'
import usePathMatch from 'src/hooks/usePathMatch.hook'
import { Noto_heading3_b20 } from 'src/styles/fonts/NotoSansKrFonts'
import { useGlobalStore } from 'src/store/zustand'

interface topMenuListType {
  to: string
  replace: boolean
  childComponent?: ReactNode
  active: boolean
}

const MainTopMenu = () => {
  const { data: categoryQueryData } =
    useCustomQuery<CategoryListSpace.Response>(categoryListQueryOption())
  const { scrollHeight } = useScrollYPosition()
  const { addUtmParameter } = usePageNav()
  const menu_position = scrollHeight >= 50
  const { match_always_discount_coupon, match_main, match_coupon_map, match_brand_list } =
    usePathMatch()
  const { alwaysSelectCategory } = useGlobalStore()

  const topMenuList: topMenuListType[] = [
    {
      to: addUtmParameter(`/main`),
      replace: true,
      childComponent: <Container $option="flex_row">핫딜</Container>,
      active: match_main,
    },
    {
      to: addUtmParameter(
        `/always/${alwaysSelectCategory || categoryQueryData?.Body?.CategoryInfo?.at(0)?.CategoryNumber || 0}`,
      ),
      replace: false,
      childComponent: '상시할인',
      active: match_always_discount_coupon,
    },
    {
      to: addUtmParameter(`/map`),
      replace: false,
      childComponent: '쿠폰맵',
      active: match_coupon_map,
    },
    {
      to: addUtmParameter(`/brand_list`),
      replace: false,
      childComponent: '브랜드',
      active: match_brand_list,
    },
  ]

  return (
    <S.TopMenuWrap $menu_position={menu_position}>
      <CustomSwiper.Wrap type="default" $wrapstyle={S.MenuSwiperStyle}>
        {topMenuList.map(
          ({ to, childComponent, replace, active }: topMenuListType, idx: number) => (
            <CustomSwiper.Item key={to} $itemstyle={S.MenuSwiperItemStyle}>
              <S.RouterLink to={to} replace={replace} $order={idx} $active={active}>
                {childComponent}
              </S.RouterLink>
            </CustomSwiper.Item>
          ),
        )}
      </CustomSwiper.Wrap>
    </S.TopMenuWrap>
  )
}

export default MainTopMenu

const S = {
  TopMenuWrap: styled.section<{ $menu_position: boolean }>`
    ${layoutMaxSize};
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--white);
    position: ${(props) => (props.$menu_position ? 'fixed' : 'absolute')};
    top: ${(props) => (props.$menu_position ? '0' : '50px')};
    left: 50%;
    transform: translate(-50%, 0%);
    z-index: ${ZIndex.TopMenu};
    padding: 0 0 0 20px;
    width: 100%;
    border-bottom: 1px solid #ededed;
  `,
  MenuSwiperStyle: css`
    display: flex;
    width: 100%;
    height: 40px;
  `,
  MenuSwiperItemStyle: css`
    margin-right: 33px;
  `,
  RouterLink: styled(Link)<{ $order: number; $active: boolean }>`
    display: flex;
    ${Noto_heading3_b20};
    line-height: 38px;
    align-items: center;
    color: var(--black-20);

    ${(props) =>
      props.$order !== 0 &&
      css`
        &:after {
          content: '';
          position: absolute;
          height: 10px;
          border-left: 1px solid var(--black-20);
          left: -16px;
        }
      `}
    ${(props) =>
      props.$active &&
      css`
        color: var(--black-90);
        border-bottom: 2px solid var(--black-100);
      `}
  `,
}
